import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import configment from '@adc/configment'
import {
  Button,
  Menu,
  Icon,
  Image,
  TransitionablePortal,
  withApplicationTheme,
  ProductLine,
} from '@adc/ui-core'
import classNames from 'classnames/bind'
import {
  mobileLoggedInDropdown,
  getNewAllDropdown,
  smartSaleMobileLoggedInDropdown,
} from '../constants/menus'
import MenuItem from '../menuItem'
import BellNotification from '../menuItem/bellNotification'
import { generalRoutes, USER_LOGIN, USER_SIGN_UP } from '../constants/routes'
import auctioncomIconLogo from '../../../img/auction-logo-mobile.svg'
import smartsaleIconLogo from '../../../img/smartsale-logo.svg'
import auctioncomLogo from '../../../img/logo-light.svg'
import Search from '../../search'
import NavigationDrawer from '../navigationDropdown/NavigationDrawer'
import {
  getNavigationMenuItems,
  isDealsForYouNavEnabled,
} from '../navigationDropdown/constants'
import cls from '../styles.scss'
const cx = classNames.bind(cls)

class MobileHeader extends PureComponent {
  static propTypes = {
    customLogo: PropTypes.string,
    featureFlags: PropTypes.object,
    isSticky: PropTypes.bool,
    liveChat: PropTypes.node,
    onLoginClick: PropTypes.func,
    onLogoutClick: PropTypes.func,
    onSignupClick: PropTypes.func,
    user: PropTypes.object,
    showSearch: PropTypes.bool,
    hasNotification: PropTypes.bool,
    showDealsForYouIndicator: PropTypes.bool,
    dealsFresh: PropTypes.bool,
    onSearchSubmit: PropTypes.func,
    onClickBell: PropTypes.func,
    bellNotificationsCount: PropTypes.string,
    filters: PropTypes.object,
    theme: PropTypes.object,
    forceSmartSaleLogo: PropTypes.bool,
    showLinks: PropTypes.bool,
    customMobileContent: PropTypes.node,
    baseUrl: PropTypes.string,
  }

  static defaultProps = {
    featureFlags: {},
    isSticky: false,
    liveChat: null,
    onLoginClick: _.noop,
    onSignupClick: _.noop,
    user: null,
    hasNotification: false,
    showSearch: true,
    onClickBell: _.noop,
    theme: {},
    showLinks: true,
    customMobileContent: null,
    baseUrl: '',
  }

  state = {
    isMenuOpen: false,
  }

  menuClose = () => this.setState({ isMenuOpen: false })

  menuToggle = () => this.setState({ isMenuOpen: !this.state.isMenuOpen })

  onSignupClick = e => {
    this.menuClose()
    this.props.onSignupClick(e)
  }

  onLoginClick = e => {
    this.menuClose()
    this.props.onLoginClick(e)
  }

  render() {
    const {
      customLogo,
      featureFlags,
      hasNotification,
      showSearch,
      user,
      onClickBell,
      bellNotificationsCount,
      filters,
      onSearchSubmit,
      theme,
      showLinks,
      forceSmartSaleLogo,
      customMobileContent,
      baseUrl,
    } = this.props
    const { isMenuOpen } = this.state
    const authRoutes = [
      {
        ...generalRoutes.logIn,
        elmId: `mh_${USER_LOGIN}`,
        onClick: this.onLoginClick,
      },
      {
        ...generalRoutes.signUp,
        elmId: `mh_${USER_SIGN_UP}`,
        onClick: this.onSignupClick,
      },
    ]

    let defaultMobileLogo
    if (theme.productLine === ProductLine.SmartSale || forceSmartSaleLogo) {
      const smartsalePoweredLogo = configment.get(
        'SMARTSALE_POWERED_LOGO_URL',
        ''
      )
      defaultMobileLogo = showSearch ? smartsaleIconLogo : smartsalePoweredLogo
    } else {
      defaultMobileLogo = showSearch ? auctioncomIconLogo : auctioncomLogo
    }

    const loggedInMenuEntries =
      theme.productLine === ProductLine.SmartSale
        ? smartSaleMobileLoggedInDropdown()
        : mobileLoggedInDropdown(true, featureFlags)
    const newAllDropdown = getNewAllDropdown(featureFlags, theme)

    const defaultLogo = (
      <div className={cx('u-pr-1')}>
        <Image
          className={cx('icon', 'mobile-icon')}
          src={customLogo || defaultMobileLogo}
          floated='left'
          data-elm-id='mh_logo'
          alt='logo'
        />
        <Icon
          className={cx(
            isMenuOpen ? 'angle-down' : 'angle-up',
            showSearch ? '' : 'wide-logo'
          )}
          name='angle down'
        />
      </div>
    )

    const isNewNavigationEnabled =
      featureFlags?.['fe.resi.enable-new-navigation']

    let menuItemsWithHandlers = []
    let formattedNotificationCount = ''

    if (isNewNavigationEnabled) {
      menuItemsWithHandlers = getNavigationMenuItems(
        featureFlags,
        {
          onSignOut: this.props.onLogoutClick,
          onNotifications: onClickBell,
          onLogin: this.onLoginClick,
          onSignUp: this.onSignupClick,
        },
        user.logged_in,
        theme,
        {
          user: this.props.user,
          isMobile: true,
          showDealsForYouIndicator: this.props.showDealsForYouIndicator,
          dealsFresh: this.props.dealsFresh,
          baseUrl,
        }
      )

      if (user.logged_in && bellNotificationsCount) {
        const count =
          typeof bellNotificationsCount === 'string'
            ? parseInt(bellNotificationsCount, 10)
            : bellNotificationsCount

        if (!isNaN(count) && count > 0) {
          formattedNotificationCount = count >= 20 ? '20+' : String(count)
        }
      }
    }

    return (
      <div data-elm-id='header' className={cx('mobile-menu')}>
        <Menu
          borderless
          className={cx(customMobileContent ? 'with-filters-and-save' : '')}
        >
          {isNewNavigationEnabled ? (
            <>
              <Menu.Item
                onClick={this.menuToggle}
                className={cx(
                  showSearch
                    ? 'mobile-menu-portal-toggle'
                    : 'mobile-wide-logo-toggle'
                )}
                data-elm-id='mh_portal_toggle'
                content={defaultLogo}
              />
              <NavigationDrawer
                user={user}
                menuItems={menuItemsWithHandlers}
                formattedNotificationCount={formattedNotificationCount}
                isOpen={isMenuOpen}
                onClose={this.menuClose}
                elmId='mh_navigation_drawer'
                indicatorsEnabled={isDealsForYouNavEnabled(featureFlags)}
              />
            </>
          ) : (
            <TransitionablePortal
              transition={{ animation: 'slide down', duration: 25 }}
              trigger={
                <Menu.Item
                  onClick={this.menuToggle}
                  className={cx(
                    showSearch
                      ? 'mobile-menu-portal-toggle'
                      : 'mobile-wide-logo-toggle'
                  )}
                  data-elm-id='mh_portal_toggle'
                  content={defaultLogo}
                />
              }
              open={isMenuOpen}
            >
              <Menu
                vertical
                size='large'
                className={cx(
                  'mobile-dropdown',
                  isMenuOpen ? 'open' : 'closed',
                  hasNotification && 'with-notification'
                )}
              >
                {!user.logged_in &&
                  authRoutes.map(item => (
                    <MenuItem
                      key={item.title}
                      {...item}
                      baseUrl={baseUrl}
                      elmId={`mh_${item.elmId}`}
                    />
                  ))}
                <MenuItem
                  className={cx('home', 'mobile-division')}
                  url='/'
                  baseUrl={baseUrl}
                  title='Home'
                  elmId='mh_home'
                />
                {user.logged_in &&
                  theme.productLine === ProductLine.AuctionCom && (
                    <BellNotification
                      bellNotificationsCount={bellNotificationsCount}
                      onClick={onClickBell}
                    />
                  )}
                {user.logged_in &&
                  loggedInMenuEntries.map((item, index) => (
                    <MenuItem key={index} {...item} baseUrl={baseUrl} />
                  ))}
                {showLinks &&
                  newAllDropdown.map((item, index) => (
                    <MenuItem key={index} {...item} baseUrl={baseUrl} />
                  ))}
                {this.props.liveChat}
                {user.logged_in && (
                  <MenuItem
                    {...generalRoutes.logOut}
                    onClick={this.props.onLogoutClick}
                    className={generalRoutes.logOut.className}
                    elmId='mh_user_logout'
                  />
                )}
              </Menu>
            </TransitionablePortal>
          )}
          {!showSearch && !user.logged_in && (
            <Menu.Menu
              position='right'
              // want to keep the space this occupies even if hidden, so that ADC logo gets shrunken the same way
              // as it is when menu is closed (less janky)
              style={{ visibility: isMenuOpen ? 'hidden' : 'visible' }}
            >
              <MenuItem
                {...generalRoutes.logIn}
                onClick={this.props.onLoginClick}
                elmId='mh_user_login'
              >
                <Button role='secondary'>Log In</Button>
              </MenuItem>
            </Menu.Menu>
          )}
          {showSearch && (
            <div
              className={cx(
                customMobileContent ? 'search-with-filters' : 'u-mt-1 u-stretch'
              )}
            >
              <Search
                elmId='mobile'
                filters={filters}
                onSearchSubmit={onSearchSubmit}
                user={user}
                categorizeResults
              />
            </div>
          )}
          {customMobileContent}
        </Menu>
      </div>
    )
  }
}

export default withApplicationTheme(MobileHeader)
const MobileHeaderNoTheme = MobileHeader
export { MobileHeaderNoTheme }
